import styled from 'styled-components';

export const EditUserWrapper: any = styled.div`

// .pageContent{
//     padding-top: 100px;
// }

.svgColor{
    color:white ! important;
}

.tabSelected{
    background:#0099FF;
    color:white ! important;
}

.editUserScreen{
    margin: 0px 0px;
}

// .EditUser{
//     text-align: center;
// }
.editUser .EditItem{
    color: #0099FF;
}

.editModule .EditItem{
    color: #0099FF;
}
.editModule .DeleteItem{
    color: #cc0000;
}
.editModule .PreviewItem{
    color: #0099FF;
}

.approveRejectUserButton .ApproveItem{
    color: #009900;
}

.approveRejectUserButton .RemoveItem{
    // color: #f50057;
    color: #cc0000;
}

// Custom Tab Section CSS
.pageTabSection{
    padding: 50px 0px; 
}
.pageTabSection .tabHeading {
    padding: 5px 25px;
    border-top: 2px solid #aaa;
}
.pageTabSection .tabHeading h3{
    font-size: 18px;
    text-transform: uppercase;
}
.pageTabSection .tab{
    border-bottom: 2px solid #0099FF;
    padding: 0px 25px;
}
.pageTabSection .tab .tabButton{
    position: relative;
    display: inline-block;
}
.pageTabSection .tab .tabButton.activeTab .btn-tab{
    background: #0099FF;
    color: #fff;
}
.pageTabSection .tab .tabButton.activeTab .MenuItem{
    color: #fff;
}
.pageTabSection .tab .btn-tab{
    position: relative;
    padding-right: 50px;
    padding: 10px 50px 10px 15px !important;
    min-height: 50px;
    border: 1px solid;
    border-radius: 0px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: 0px;
    color: #000;
    border-color: #0099FF;
}
.pageTabSection .tab .tabButton .tabSelected:hover{
    background: #0099FF;
}
.pageTabSection .tab .tabSelected + div .MenuItem{
    color: #ffffff;
}
.pageTabSection .tab .tabButton:hover{
    background: #fff;
}
.pageTabSection .tab .btn-addtab{
    padding-right: 15px !important;
    color: #0099FF;
}
.pageTabSection .tab .cancelButton{
    color: #cc0000;
}
.pageTabSection .tab .MenuItem{
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1000;
}
.pageTabSection .tab .selectCountryTab{
    color: #0099FF;
    font-weight: bold;
    border: 2px solid;
    border-bottom: 0px;
    padding: 0px 16px;
    font-size: 0.875rem;
    min-width: 64px;
    box-sizing: border-box;
    // border-radius: 4px;
    text-transform: uppercase;
    display: inline-block;
    border-radius: 0px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: 0px;
}
.selectCountryTab .countrySelection{
    display: inline-block;
    vertical-align: middle;   
    margin: 5px 10px;
}
// Custom Tab Section CSS

.pageTabSection table thead{
    // border-top: 2px solid #aaa;
    border-bottom: 2px solid #aaa;
} 

.pageTabSection table tbody tr th{
    font-size: 16px;
} 
.pageTabSection table tbody tr td{
    font-size: 16px;
}

.pageTabSection table tbody tr td .tablePageIndex a{
    padding: 0px 5px;
    border-left: 1px solid #ccc;
    color: #000;
    font-size: 14px !important;
}
.pageTabSection table tbody tr td .tablePageIndex a:first-child{
    border-left: 0px;  
}
.pageTabSection .tabContent table thead tr th {
    color: #000;
    font-size: 14px;
}
.pageTabSection .tabContent table tbody tr th * {
    font-size: 18px !important;
}
.pageTabSection .tabContent table tbody tr td * {
    font-size: 18px !important;
}
.pageTabSection .tabContent table tbody  tr td{
    font-size: 18px !important;
}

`;


// WEBPACK FOOTER //
// ./src/styles/edituser.tsx